module.exports = __webpack_public_path__ + "img/phbbtn.932f6ca9.png";